import { asArray } from './asArray';

export const resolveBrandName = (
  submission: any,
  brandLookup?: Map<string, string>,
  brandId?: string,
  brandName?: string
): string => {
  const explicit =
    brandName ||
    submission?.brandName ||
    submission?.brand?.name;
  if (explicit) return explicit;

  const id = brandId || submission?.brandId;
  if (brandLookup && id && brandLookup.get(id)) return brandLookup.get(id)!;

  const fromList = asArray(submission?.brands)
    .map((b: any) => {
      if (typeof b === 'string') return brandLookup?.get(b) || b;
      return brandLookup?.get(b?.id) || b?.name || b?.id;
    })
    .find(Boolean);
  if (fromList) return fromList as string;

  if (id) return `Brand #${id}`;
  return 'Unknown brand';
};

export const getBrandSuffix = (brandName?: string, maxLen = 3): string => {
  if (!brandName) return '';
  const cleaned = brandName.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (!cleaned) return '';
  const len = Math.min(Math.max(cleaned.length >= 4 ? 4 : 2, 2), maxLen);
  return cleaned.slice(0, len);
};

export const formatSubmissionCode = (
  submissionId?: string,
  brandName?: string,
  mode: 'bullet' | 'suffix' = 'bullet'
): string => {
  const id = submissionId || 'Unassigned';
  const suffix = getBrandSuffix(brandName);
  if (mode === 'suffix' && suffix) {
    return `${id}-${suffix}`;
  }
  if (mode === 'bullet' && brandName) {
    return `${id} • ${brandName}`;
  }
  return id;
};
